<template>
	<div class="booking-receipt__data bookinbar_wrap">

		<div class="subscription__block">
			<h3>{{ $store.state.subscription.headline }}</h3>
			<div class="table right_price">
				<p>{{ this.$store.state.subscription.title }}</p>
				<p v-html="price + ' ' + $store.state.language.monthly"></p>
			</div>
		</div>

		<div class="subscription__block">
				{{ $store.state['activation_date'] }}
				<div class="form-row">
					<input type="text" v-if="activationDates.length" :value="activationDates[0].title" readonly disabled="disabled">
				</div>
		</div>

		<input name="activationdate" type="hidden" :value="activationDates[0].value">
		<input name="subscriptionCurrency" type="hidden" v-model="chosenCurrency">

		<Total />

		<Button :currently-loading="currentlyLoading" />

		<StickyWidget></StickyWidget>
	</div>
</template>

<script>

import Button from './components/widget/Button'
import Total from './components/widget/Total'
import StickyWidget from '@/components/widget/StickyWidget';

export default {
	name: 'Subscriptionwidget',
	components: {
		StickyWidget,
		Button,
		Total
	},
	data: function(){
		return {
			hasAttention: false,
			errorClasses: [],
			windowWidth: window.innerWidth,
			price: ''
		}
	},
	mounted() {

		window.onresize = function(){
			this.windowWidth = window.innerWidth
		}


		// generate "total" and "taxes"
		window.vue_baseConfig.total = [
			{
				"title": this.$store.state.language.total,
				"value": [
					"<span class='pricetag' data-currency='"+this.subscription.currency+"' data-value='"+this.subscription.price+"'>"+this.subscription.priceShort+"</span>"
				]
			}
		]
		this.price = this.$store.state.total[0].value[0]
		window.vue_baseConfig.taxes = {
			'title': this.price + " " + this.$store.state.language.perMonth
		};

		this.$store.commit('initializeActivationdateValue')

		let initData = false

		// set inital data?!

		if(initData) {
			this.$store.dispatch('loadAvailability')
		}

		// events from the outside
		const toggle = document.querySelector('a[data-target="#booking-receipt"]');
		if(toggle && !toggle.classList.contains('edit-toggle--info')) {
			toggle.addEventListener('click', this.startEditmode)
		}

		const wrap = document.querySelector('#booking-receipt')
		if(wrap) {
			const that = this
			wrap.addEventListener('change:invisible', function(){
				that.currencyPopupOpened = false
			})
		}

		this.$store.commit('setActivationValue', this.activationDates[0].value)

	},

	computed: {
		activationValue: {
			get: function() {
				return this.$store.state.activationValue
			},
			set: function(val) {
				return this.$store.commit('setActivationValue', val)
			}
		},
		subscription: function (){
			return this.$store.state.subscription
		},
		activationDates: function (){
			return this.$store.state.activationDates
		},
		currentlyLoading: function () {
			return this.$store.state.currentlyLoading
		},
		errorShowTime: function () {
			return this.$store.state.errorShowTime
		},
		chosenCurrency: function(){
			return this.$store.state.propertyCurrency
		}
	},

	methods: {
		startEditmode() {
			this.$store.dispatch('enterEditmode')
		}
	}
}
</script>